export const PXForm = (function () {
	'use strict';

	function init() {
		let formPreviews = document.querySelectorAll('.form-preview-link');

		if (formPreviews.length === 0) return;

		formPreviews.forEach((f) => {
			f.href = '/?preview_id=' + wp.data.select('core/editor').getCurrentPost().id;
		});
	}

	function events() {}

	return {
		init: init,
	};
})();
